export enum SaleOrderStatus {
    Waiting = 1,
    Started = 2,
    Finished = 3,
}
